// extracted by mini-css-extract-plugin
export default {"root":"FoundingMemberBadge_root__PMkQ3"};